import Vue from 'vue';
import  Vuex from 'vuex';

Vue.use(Vuex);
import userModule from './module/userModule'

export default new Vuex.Store({
  modules:{
    userModule
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js